import { pluralise } from '@/app/utils/formatPluralise';

export function manualSearchResultMessage(result: {
    total_results: number;
    truncated: boolean;
}): string {
    const found = pluralise('vehicle', result.total_results, true);

    return result.truncated
        ? `Showing the first ${found} — narrow your search to see the rest`
        : `Found ${found}`;
}
